module.exports = __webpack_public_path__ + "img/bottom.584d2ad3.png";